import { render } from "./AffectedUnitsList.vue?vue&type=template&id=8259327a"
import script from "./AffectedUnitsList.vue?vue&type=script&lang=js"
export * from "./AffectedUnitsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__